import React, { memo } from "react";
import { MenuOfferCommon } from "../commercial-menu-offer-common";
import { CommercialService } from "../../../services/commercial-service";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Menu } from "../../../types";
interface IMenuItem {
  menu: Menu;
  rightFooter?: JSX.Element;
  unavailable?: boolean;
  canInteract?: boolean;
  unavailableReasonKey?: string;
}

const Legend = styled.div`
  width: 100%;
  text-align: right;
  font-size: 12px;
  color: ${(props) => props.theme.disabledColor};
  margin-top: 2px;
  margin-bottom: -6px;
`;

const CommercialMenuActions = styled.div`
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  margin-top: auto;
  .MuiCheckbox-root {
    padding: 0px 2px;
  }
`;

const MenuItem = (props: IMenuItem) => {
  const { t, i18n } = useTranslation();
  const unavailableReasonKey =
    props.unavailableReasonKey ?? "instabook.menus.errors.unavailable";
  const commercialService = new CommercialService(props.menu, i18n.language);
  return (
    <MenuOfferCommon
      disabled={!(props.canInteract ?? true)}
      commercialService={commercialService}
    >
      <CommercialMenuActions>
        {props.rightFooter}
        {props.unavailable && <Legend>{t(`${unavailableReasonKey}`)}</Legend>}
      </CommercialMenuActions>
    </MenuOfferCommon>
  );
};

export const CommercialMenu = memo(MenuItem);
